export enum ConfigManagerProperties {
  production = 'production',
  region = 'region',
  buildVersion = 'buildVersion',
}
